import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Layers, Loader2 } from "lucide-react";
import { reApi, errMsg } from "@/lib/residentApi";
import { btnGold } from "@/components/nds/windows/finance/parts";

/** Session Pillars step: assign the next week of all 4 pillars in one tap — only when none of the 4 is open. */
export default function AssignAllPillars({ residentId, onDone }) {
  const [open, setOpen] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => reApi.get(`/residents/${residentId}/pillar-summary`).then((d) => setOpen(d.assignments.filter((a) => a.status !== "staff_assessed").length)).catch(() => setOpen(0));
  useEffect(() => { load(); }, [residentId]); // eslint-disable-line react-hooks/exhaustive-deps
  const go = async () => {
    setBusy(true);
    try { const r = await reApi.post(`/residents/${residentId}/pillar-assignments/assign-all`); toast.success(`All 4 pillars assigned · Week ${r.assignments[0]?.program_week}`); load(); onDone?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (open == null) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 p-3 border border-nex-gold/30 rounded-sm" data-testid="ss-assign-all">
      <button type="button" disabled={busy || open > 0} onClick={go} data-testid="ss-assign-all-btn" className={`${btnGold} inline-flex items-center gap-1.5`}>
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Layers className="h-3 w-3" />} Assign all 4 pillars</button>
      <span className="text-xs text-nex-muted" data-testid="ss-assign-all-note">{open > 0 ? `${open} pillar${open === 1 ? " is" : "s are"} still open — finish or verify ${open === 1 ? "it" : "them"} first` : "Assigns next week's lesson for all 4 pillars at once"}</span>
    </div>
  );
}
